import {
	type ZodErrorMap,
	type ZodInvalidStringIssue,
	type ZodInvalidTypeIssue,
	ZodIssueCode,
	type ZodTooBigIssue,
	type ZodTooSmallIssue,
	z,
} from "zod";

const handleInvalidType = (issue: ZodInvalidTypeIssue) => {
	if (issue.received === "undefined") {
		return { message: "必須項目です。" };
	}
	return { message: "無効な入力です。正しい形式で入力してください。" };
};

const handleTooSmall = (issue: ZodTooSmallIssue) => {
	if (issue.type === "string") {
		return issue.minimum === 1
			? { message: "必須項目です。入力してください。" }
			: { message: `${issue.minimum} 文字以上で入力してください。` };
	}
	if (["number", "bigint"].includes(issue.type)) {
		return { message: `${issue.minimum} 以上で入力してください。` };
	}
	if (issue.type === "array") {
		return { message: `${issue.minimum}つ以上入力してください。` };
	}
	if (issue.type === "date") {
		return { message: `${issue.minimum} 以降の日付を選択してください。` };
	}
	return { message: `${issue.minimum} 以上で入力してください。` };
};

const handleTooBig = (issue: ZodTooBigIssue) => {
	if (issue.type === "string") {
		return { message: `${issue.maximum} 文字以下で入力してください。` };
	}
	if (["number", "bigint"].includes(issue.type)) {
		return { message: `${issue.maximum} 以下で入力してください。` };
	}
	if (issue.type === "array") {
		return { message: `${issue.maximum}つ以下で入力してください。` };
	}
	if (issue.type === "date") {
		return { message: `${issue.maximum} 以前の日付を選択してください。` };
	}
	return { message: `${issue.maximum} 以下で入力してください。` };
};

const handleInvalidString = (issue: ZodInvalidStringIssue) => {
	if (issue.validation === "email") {
		return { message: "正しいメールアドレス形式で入力してください。" };
	}
	if (issue.validation === "url") {
		return { message: "正しいURL形式で入力してください。" };
	}
	return {
		message: "入力形式に間違いがあります。正しい形式で入力してください。",
	};
};

const customErrorMap: ZodErrorMap = (issue, _ctx) => {
	switch (issue.code) {
		case ZodIssueCode.invalid_type:
			return handleInvalidType(issue);
		case ZodIssueCode.too_small:
			return handleTooSmall(issue);
		case ZodIssueCode.too_big:
			return handleTooBig(issue);
		case ZodIssueCode.invalid_string:
			return handleInvalidString(issue);
		default:
			return { message: "無効な入力です。正しい形式で入力してください。" };
	}
};

export const customizeZodErrorMap = () => {
	z.setErrorMap(customErrorMap);
};
